<template>
  <transition name="fade">
    <div class="pnlDialogBg" v-show="show" style="animation-duration: 0.3s">
      <div class="pnlDialogAlpha" @click.self="CloseDialog">
        <div class="pnlDialogMsg">
          <div class="pnlTitle">
            <label>{{ title }}</label>
            <img class="btnDialogXX" src="@/assets/img/controller/icon_close.png" @click="CloseDialog" />
          </div>
          <div class="pnlContent">
            <label class="lblContent" v-html="content"></label>
            <div class="pnlBtnArea">
              <button class="btnLeft" @click="BtnLeftClick" v-show="twoBtn">
                {{ btnLeftText }}
              </button>
              <button class="btnRight" @click="BtnRightClick">
                {{ btnRightText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'DialogMsg',
  props: {
    show: Boolean,
    title: String,
    content: String,
    btnRightText: String,
    btnLeftText: String,
    twoBtn: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    CloseDialog() {
      this.$emit('close-dialog');
    },
    BtnRightClick() {
      this.$emit('btn-right-click');
    },
    BtnLeftClick() {
      this.$emit('btn-left-click');
    },
  },
};
</script>